import React, { FunctionComponent, useEffect, useState } from 'react';
import classNames from 'classnames';
import axios from 'axios';
import * as jsonpAdapter from 'axios-jsonp';

import style from './BuyButton.module.less';

const USE_SANDBOX = false;
const PADDLE_PRICES_ENDPOINT = (USE_SANDBOX as boolean) ? 'https://sandbox-checkout.paddle.com/api/2.0/prices' : 'https://checkout.paddle.com/api/2.0/prices';

let gtag = (() => console.log('no gtag')) as any;
if (typeof window !== 'undefined') {
  gtag = (window as any).gtag || gtag;
}

interface PriceState {
  discountedTotal?: string;
  total?: string; // PLN 77.60
}

interface PaddlePrices {
  price: {
    gross: string; // US$70.00
    net: string; // US$58.33
    tax: string; // US$11.67
    tax_included: boolean;
  };
  quantity: number;
  country: string;
}

const PRODUCTS = {
  unboxing: {
    prodId: 764461,
    sandboxId: 26656
  },
  'secret-lab': {
    prodId: 766797,
    sandboxId: 27172
  }
};

interface BuyButtonProps {
  placement?: string;
  product: 'unboxing' | 'secret-lab';
  text?: string;
  onClick?: () => void;
}

export const BuyButton: FunctionComponent<BuyButtonProps> = (props) => {
  const [price, setPrice] = useState<PriceState>({
    total: 'Loading...'
  });

  const productId = (PRODUCTS[props.product] || {})[USE_SANDBOX ? 'sandboxId' : 'prodId'];

  useEffect(() => {
    async function fetchAndUpdatePrice() {
      // @see: https://developer.paddle.com/api-reference/b3A6MzA4NjA4Mjc-get-prices
      const response = await axios.get(PADDLE_PRICES_ENDPOINT, {
        adapter: jsonpAdapter,
        params: {
          product_ids: productId
        },
        headers: {
          'Content-Type': 'application/json'
        }
      });

      const paddleCurrency = `${response.data.response.products[0].currency}`; // discounted, if discounted
      const paddleListPrice = response.data.response.products[0].list_price.gross; // original
      const paddlePrice = response.data.response.products[0].price.gross; // discounted, if discounted
      const total = new Intl.NumberFormat('en-EN', { style: 'currency', currency: paddleCurrency }).format(paddleListPrice)
      const discountedTotal = new Intl.NumberFormat('en-EN', { style: 'currency', currency: paddleCurrency }).format(paddlePrice)
      const isDiscounted = paddlePrice !== paddleListPrice;

      if (!response.data.success) {
        setPrice({ total: 'Failed to fetch the price...' });
        return;
      }

      if (isDiscounted) {
        setPrice({ total, discountedTotal });
      } else {
        setPrice({ total });
      }
    }
    fetchAndUpdatePrice();
  }, []);

  return (
    <button
      type="button"
      className={classNames(style.buy)}
      onClick={(ev) => {
        ev.preventDefault();
        props.onClick && props.onClick();
        gtag('event', 'begin_checkout');
        gtag('event', 'conversion', {
          send_to: 'AW-1009966997/lRCRCOez_PACEJW_y-ED'
        });
        gtag('event', 'click', {
          event_category: 'BuyButton',
          event_label: props.placement || 'unknown placement'
        });
        Paddle.Checkout.open({ product: productId });
      }}
    >
      <span className={style.tag}>{props.text || 'BUY'}</span>
      <p className={style.priceWrapper}>
        <span className={classNames(style.price, price.discountedTotal && style.oldPrice)}>{price.total}</span>
        {price.discountedTotal ? <span className={style.pPrice}>{price.discountedTotal}</span> : <></>}
      </p>
    </button>
  );
};
